module.exports = __webpack_public_path__ + "static/media/cat404.4e2e36ee.png";